module.exports = new __parcel__URL__("Bluff.f58aed4d.png").toString();